export default "__VITE_ASSET__BHUPyj1H__"